import React, { useState } from 'react';
import './App.css';
import Logo from './components/Logo';
import SnakeGame from './components/SnakeGame';

function App() {
  const [gameMode, setGameMode] = useState(false);

  const handleLogoClick = (clickCount) => {
    if (clickCount >= 5) {
      setGameMode(true);
    }
  };

  const handleGameEnd = () => {
    setGameMode(false);
  };

  return (
    <div className="App">
      <div className="background-grid"></div>
      <div className="background-glow"></div>
      
      {!gameMode ? (
        <header className="App-header">
          <Logo onLogoClick={handleLogoClick} />
        </header>
      ) : (
        <div className="game-container">
          <SnakeGame onGameEnd={handleGameEnd} />
        </div>
      )}
    </div>
  );
}

export default App;